import gql from 'graphql-tag';

export const syncFacialDevice = gql`
  mutation syncFacialDevice($deviceId: Int!) {
    syncFacialDevice(deviceId: $deviceId)
  }
`;

export const resolveDeviceDivergences = gql`
  mutation resolveDeviceDivergences(
    $deviceId: Int!
    $items: [ResolveDeviceDivergenceItemInput!]!
  ) {
    resolveDeviceDivergences(deviceId: $deviceId, items: $items) {
      success
      inProgress
      messageError
    }
  }
`;

export const forceDeviceConnection = gql`
  mutation forceDeviceConnection($deviceId: Int!) {
    forceDeviceConnection(deviceId: $deviceId)
  }
`;

export const rebootDevice = gql`
  mutation rebootDevice($deviceId: ID!) {
    rebootDevice(deviceId: $deviceId)
  }
`;

export const checkDeviceExist = gql`
  mutation checkDeviceExist($deviceId: String!, $type: String!) {
    checkDeviceExist(deviceId: $deviceId, type: $type)
  }
`;

export const deviceParamsConfig = gql`
  mutation deviceParamsConfig($deviceId: ID!, $data: [DeviceFormParamsInput]!) {
    deviceParamsConfig(deviceId: $deviceId, data: $data)
  }
`;

export const createAta = gql`
  mutation createAta($device: AtaDeviceInput!) {
    createAta(device: $device)
  }
`;
export const createIntercom = gql`
  mutation createIntercom($device: IntercomDeviceInput!) {
    createIntercom(device: $device)
  }
`;

export const editIntercom = gql`
  mutation editIntercom($device: IntercomDeviceInput!) {
    editIntercom(device: $device)
  }
`;

export const removeIntercom = gql`
  mutation removeIntercom($deviceId: ID!) {
    removeIntercom(deviceId: $deviceId)
  }
`;

export const syncMultiBuildingConfigurations = gql`
  mutation syncMultiBuildingConfigurations(
    $deviceId: ID!
    $configOption: String!
  ) {
    syncMultiBuildingConfigurations(
      deviceId: $deviceId
      configOption: $configOption
    )
  }
`;

export const removeDeviceMultiBuildingConfiguration = gql`
  mutation removeDeviceMultiBuildingConfiguration($deviceId: Int!) {
    removeDeviceMultiBuildingConfiguration(deviceId: $deviceId)
  }
`;

export const updateDeviceCredentials = gql`
  mutation updateDeviceCredentials(
    $deviceId: ID!
    $user: String!
    $password: String!
    $passwordConfirmation: String!
    $reason: String!
  ) {
    updateDeviceCredentials(
      deviceId: $deviceId
      user: $user
      password: $password
      passwordConfirmation: $passwordConfirmation
      reason: $reason
    )
  }
`;

export const syncDevicePasswordBySerialNumber = gql`
  mutation syncDevicePasswordBySerialNumber(
    $deviceId: ID!
    $serialNumber: String!
    $reason: String!
  ) {
    syncDevicePasswordBySerialNumber(
      deviceId: $deviceId
      serialNumber: $serialNumber
      reason: $reason
    )
  }
`;

export const updateDeviceUnitiesGroupMultibuildingConfig = gql`
  mutation updateDeviceUnitiesGroupMultibuildingConfig(
    $deviceId: ID!
    $selectedIds: [String!]!
  ) {
    updateDeviceUnitiesGroupMultibuildingConfig(
      deviceId: $deviceId
      selectedIds: $selectedIds
    )
  }
`;

export const sendImportDeviceConfiguration = gql`
  mutation sendImportDeviceConfiguration(
    $deviceId: ID!
    $body: ImportDeviceConfigurationInput!
  ) {
    sendImportDeviceConfiguration(deviceId: $deviceId, body: $body)
  }
`;

export const addDeviceStorage = gql`
  mutation addDeviceStorage($device: DeviceCreateInput!) {
    addDeviceStorage(device: $device) {
      id
    }
  }
`;

export const condominiumPasswordActivate = gql`
  mutation condominiumPasswordActivate($condominiumId: ID!, $email: String) {
    condominiumPasswordActivate(condominiumId: $condominiumId, email: $email)
  }
`;

export const testVideoChannelConnection = gql`
  mutation testVideoChannelConnection($condominiumId: ID!, $cameraId: ID!) {
    testVideoChannelConnection(
      condominiumId: $condominiumId
      cameraId: $cameraId
    ) {
      cameraId
      steps {
        key
        status
        detail
        milliseconds
      }
      ranAt
    }
  }
`;

export const testDeviceConnection = gql`
  mutation testDeviceConnection(
    $condominiumId: Int!
    $input: DeviceConnectionTestInput!
  ) {
    testDeviceConnection(condominiumId: $condominiumId, input: $input) {
      result
      fields {
        field
        status
        reason
        detail
      }
      ranAt
    }
  }
`;
